import React from "react"
import { AppRouteProps } from "@harea/component"
import { SubscriptionRoutes } from "./views/subscription/SubscriptionRoutes"
import { PaymentMethodRoutes } from "./views/paiement-method/PaymentMethodRoutes";
import { PaymentsRoutes } from "./views/list/PaymentsRoutes"
import { LicensesRoutes } from "./views/licenses/LicensesRoutes"
import { FeaturesRoutes } from "./views/features/FeaturesRoutes"
const ListPayingContainer = React.lazy(() => import("./container/ListPayingContainer"))
const PaymentsList = React.lazy(() => import("./views/list/container/PaymentsList"))


export const PayingRoutes = [
    {
        path: "billing",
        title: "std_subscription",
        element: <ListPayingContainer />,
        // roles: ["DASHBOARD_ADMIN_RH"],
        children: [
            ...SubscriptionRoutes,
            ...PaymentsRoutes,
            ...PaymentMethodRoutes,
            ...LicensesRoutes,
            ...FeaturesRoutes,
        ]
    },
] as Array<AppRouteProps>
